import axios from "axios";
import qs from "qs";
import cookie from "js-cookie";
// import env from "@libs/util/environment.js";
class MinigamesApi {
  constructor() {
    /**
     * @protected
     */
    this.invalid_csrf = false;
    this._axios = this._getAxios();
    this.error_handler = false;
    this.repeat_token = false;
  }
  setBaseUrl(base_url) {
    this._axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
    this._axios.defaults.baseURL = base_url;
  }

  /**
   * @protected
   * @return {AxiosInstance} axios instance
   */
  _getAxios() {
    return axios.create({
      baseURL: "https://api.example.com",
    });
  }
  registerErrorHandler(error_handler) {
    this.error_handler = error_handler;
  }

  userInfo() {
    cookie.remove("mg_token", { path: "/" });
    return new Promise((resolve, reject) => {
      return this.call({ method: "get", baseURL: "/", url: "minigames/user/info" }).then(
        response => {
          if (response.success) {
            cookie.set("mg_token", response.success.data.data.token, { path: "/", expires: 7 });
            resolve(response);
          } else {
            reject(response);
          }
        }
      );
    });
  }

  /**
   * Now it's only for  ru Archeage, untested on other projects; be careful.
   * @return {Promise<any>}
   */
  projectUserInfo() {
    return new Promise((resolve, reject) => {
      // const url = env.isMailRu() ? "/minigames/user/info" : "dynamic/auth/?a=checkuser";
      // const url = env.isMailRu()
      //   ? "dynamic/user/check_data.php?do=auth"
      //   : "dynamic/auth/?a=checkuser";

      const url = "/minigames/user/info";

      return this.call({ method: "get", baseURL: "/", url }).then(response => {
        if (response.success) {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  }

  call(method, url, data, responseType = "json") {
    let headers = {};
    let params = {};
    if (method === "get") {
      params = data;
    }
    if (method === "post") {
      headers["Content-Type"] = "application/x-www-form-urlencoded";
      data = typeof data === "object" ? qs.stringify(data) : data;
    }
    //support raw axios call; be careful! UNTESTED ON POST REQUESTS (need convert data by qs and smth other..)
    if (typeof method === "object") {
      params = method;
    } else {
      params = {
        method,
        url,
        data,
        params,
        headers,
        responseType,
      };
    }
    return this._axios(params)
      .then(response => {
        return {
          success: {
            data: response.data,
            status: response.status,
          },
        };
      })
      .catch(error => {
        //если токен протух
        if (error.response.data.data.code === 10 && error.response.data.state === "Fail") {
          //перезапросим токен и вызовем заново исходный метод
          if (!this.repeat_token) {
            this.repeat_token = true;
            return this.userInfo().then(() => {
              return this.call(method, url, data, responseType);
            });
          } else {
            setTimeout(() => {
              return this.userInfo().then(() => {
                this.repeat_token = false;
                return this.call(method, url, data, responseType);
              });
            }, 20000);
          }
        } else {
          if (this.error_handler) {
            this.error_handler({ data: error.response.data.data });
          }
          return {
            error: error.response.data,
          };
        }
      });
  }

  get(url, data) {
    return this.call("get", url, data);
  }

  post(url, data) {
    return this.call("post", url, data);
  }
}
export default MinigamesApi;
